<div class="header">
    <img style="margin-left: 1rem!important;vertical-align: middle;" src="assets/Images/logo.png" alt="Codelco" class="ml-3">
</div>
<div class="container">
    <h2 style="padding-left: 20px;">Aplicativos Codelco</h2>
    <div class="flex justify-content-around  flex flex-wrap">
        <div *ngFor="let app of apps">
            <div class="card">
                <p-card>
                    <ng-template pTemplate="header">
                        <div style="font-weight: bold;text-align: center;padding-top: 2rem;">{{app.nombre}}</div>
                        <br>
                        <a [routerLink]="['/aplicativos',app.id]">
                            <div style="display: flex;justify-content: center">
                                <img class="icono" alt="Card" src="{{app.logo+'?'+timestamp}}">
                            </div>
                        </a>
                    </ng-template>
                    
                    <div class="flex justify-content-around  flex flex-wrap" style="padding: 5um;">
                        <a href='{{app.android+"?"+timestamp}}'><p-button label="Android" icon="pi pi-android" styleClass="p-button-sm p-button-success"></p-button></a>
                        <a href='{{app.ios}}'><p-button label="IOS" icon="pi pi-apple" styleClass="p-button-sm p-button-secondary"></p-button></a>
                    </div>
                </p-card></div>
        </div>
    </div>
    
    <div class="titulo" style="padding-top: 2rem;padding-bottom: 90px;">
        <a *ngIf="idApp==1" href='{{"http://appsgobm.com/aplicativos_codelco/recursos/video.mp4"+"?"+timestamp}}' style="width: fit-content; display: block; margin: auto;">
            <div class="videoInstructivo">
                <i class="pi pi-video" style="color: white; font-size: 1rem;"></i>&nbsp;
                <span class="tituloInstructivo">Video instructivo Autotesteo</span> 
            </div>
        </a>
        <a *ngIf="idApp==1" href='{{"http://appsgobm.com/aplicativos_codelco/recursos/paso_a_paso_autotesteo.pdf"+"?"+timestamp}}' style="width: fit-content; display: block; margin: auto;">
            <div class="manual">
                <i class="pi pi-file" style="color: black; font-size: 1rem;"></i>&nbsp;
                <span class="tituloManual">Manual Autotesteo</span> 
            </div>
        </a>
        <a href='{{"http://appsgobm.com/aplicativos_codelco/apps/instructivo.png"+"?"+timestamp}}' style="width: fit-content; display: block; margin: auto;">
            <div class="instructivo">
                <span class="tituloInstructivo">1ra app Codelco?</span><br>
                <span class="subTituloInstructivo">Revisa el instructivo </span><i class="pi pi-apple" style="color: white; font-size: 1rem;"></i><span style="color: white;"> aquí</span>
                
            </div>
        </a>
    </div>
</div>
<div class="footer" style="display: flex;justify-content: center">
    <img style="margin-left: 1rem!important;vertical-align: middle;padding: 15px;" src="assets/Images/logo.png" alt="Codelco" class="ml-3">
</div>